import { DropdownMenu2 } from '@kc-console/common-ui';
import { useDeleteFavoriteService, useScopedNavigation } from '@kc-console/context';
import { useTranslation } from '@kc-console/core';

import type { DropdownMenu2Props } from '@kc-console/common-ui';
import type { FavoriteService } from '@kc-console/context';

type FavoriteItemMenuProps = {
  service: FavoriteService;
} & Omit<DropdownMenu2Props, 'items'>;

/**
 * 즐겨찾기 항목의 컨텍스트 메뉴 컴포넌트입니다.
 * @description
 * - 새 탭으로 열기 및 즐겨찾기 제거 기능을 제공합니다.
 * - GNB 스타일과 일치하는 드롭다운 메뉴를 표시합니다.
 */
const FavoriteItemMenu = ({ service, ...props }: FavoriteItemMenuProps) => {
  const { t } = useTranslation();
  const { mutate: deleteFavoriteService } = useDeleteFavoriteService();
  const { getScopedPath } = useScopedNavigation();

  const handleOpenNewTab = () => {
    window.open(getScopedPath(service.path), '_blank', 'noopener,noreferrer');
  };

  const handleRemoveFavoriteItem = () => {
    deleteFavoriteService(service);
  };

  return (
    <DropdownMenu2
      items={[
        {
          text: t('layout:favorite.menu.open_new_tab'),
          onClick: handleOpenNewTab,
        },
        {
          text: t('layout:favorite.menu.remove'),
          onClick: handleRemoveFavoriteItem,
        },
      ]}
      {...props}
    />
  );
};

export default FavoriteItemMenu;
